import { useEffect, useState } from 'react'

/**
 * Whether a CSS media query matches, kept current as the viewport changes.
 * False where `matchMedia` is absent (tests, SSR), so components fall back
 * to their phone rendering there.
 */
export function useMediaQuery(query: string): boolean {
  const supported = typeof window !== 'undefined' && typeof window.matchMedia === 'function'
  const [matches, setMatches] = useState(() => (supported ? window.matchMedia(query).matches : false))
  useEffect(() => {
    if (!supported) return
    const mql = window.matchMedia(query)
    const onChange = () => setMatches(mql.matches)
    onChange()
    mql.addEventListener('change', onChange)
    return () => mql.removeEventListener('change', onChange)
  }, [query, supported])
  return matches
}

/** Tailwind's `lg` breakpoint: where the app lays out for a desktop. */
export const DESKTOP_QUERY = '(min-width: 1024px)'
export function useIsDesktop(): boolean {
  return useMediaQuery(DESKTOP_QUERY)
}
